import { Link, useLocation } from "react-router-dom";

export const AdminTabs = () => {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/admin", label: "Weekly Additions" },
    { to: "/admin/pages", label: "Book Pages" },
  ];
  return (
    <div className="flex gap-2 mb-10 border-b border-archive-border">
      {tabs.map((t) => {
        const active = pathname === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`admin-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`font-mono text-xs tracking-widest uppercase px-5 py-3 -mb-px border-b-2 transition-colors ${
              active
                ? "border-oxblood text-oxblood"
                : "border-transparent text-text-muted hover:text-ink"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
};
